<template>
  <hsc-window-style-white>
    <hsc-window
      :is-open="isVisibleExportPDFReportViewer"
      :title="`Exporting - ${getCurrentReportViewer.name}`"
      :min-height="125"
      :min-width="285"
      :width="475"
      :height="195"
      position-hint="center"
      class="export-window"
    >
      <div
        v-if="isLoading"
        id="loading-animation"
      >
        <b-spinner
          variant="primary"
          label="Loading"
        />
      </div>
      <b-container
        v-else
        class="main-container m-0 p-0"
        fluid
      >
        <b-row
          align-v="center"
          align-h="start"
          class="m-1 my-3"
        >
          <b-col md="auto">
            <p
              class="mb-0 label-input-text"
            >
              File Name:
            </p>
          </b-col>
          <b-col>
            <b-form-input
              v-model="fileName"
              :state="fileNameValidation(fileName)"
              aria-describedby="input-live-help input-live-feedback"
              placeholder="File name"
              size="sm"
            />
            <b-form-invalid-feedback class="input-live-feedback">
              The field is required and should be a valid file name
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row
          align-v="center"
          align-h="start"
          class="m-1 my-3"
        >
          <b-col md="auto">
            <p
              class="mb-0 label-input-text"
            >
              Page Size:
            </p>
          </b-col>
          <b-col md="auto">
            <b-dropdown
              split
              split-variant="outline-primary"
              variant="primary"
              :text="selectionPageSize"
              class="mt-1 combobox-config shadow-sm"
              size="sm"
            >
              <b-dropdown-item @click="changeSelectionPageSize('Single Page')">
                Single Page
              </b-dropdown-item>
              <b-dropdown-item @click="changeSelectionPageSize('A4')">
                A4
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
        <b-row
          align-v="center"
          align-h="end"
          class="m-1 mt-2"
        >
          <b-form-checkbox
            v-model="showSignatureValue"
            class="config-checkbox"
          >
            Show Signature
          </b-form-checkbox>
        </b-row>
      </b-container>
      <div class="btns-commands buttons-page">
        <b-button
          variant="danger"
          class="mr-3"
          @click="closeAction"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          @click="exportPDF"
        >
          Export
        </b-button>
      </div>
    </hsc-window>
  </hsc-window-style-white>
</template>

<script>
//https://github.com/michitaro/vue-window
import { mapGetters, mapActions } from 'vuex'
import domtoimage from 'dom-to-image';
import headerReport from '@/assets/reportBoard/header.png'
import { jsPDF } from 'jspdf';

const notifyZone='ExportPDF'
const exporting_Message='Exporting report as PDF...'

const RE_PDF_EXT = /\.pdf$/i
const RE_VALID_FILENAME = /^[^\\/:*?"<>|]+$/

export default {
  name: 'ExportPDF',
  data() {
    return {
      isLoading:false,
      selectionPageSize:'Single Page',
      showSignatureValue:false,
      headerImage:null,
      headerReport,
      fileName:'',
    }
  },
  computed: mapGetters(['getCurrentReportViewer','isVisibleExportPDFReportViewer','getCurrentReportViewer','isEditModeReportViewer']),
  watch:{
    isVisibleExportPDFReportViewer(newValue){
      if(newValue){
        this.fileName = `${this.getCurrentReportViewer.name}.pdf`
      }
    }
  },
  created(){
    const imgAux = new Image();
      //imgAux.setAttribute('crossOrigin', 'anonymous');
    imgAux.onload = ( function (parent) {
      return async function () {
        let canvas = document.createElement('canvas');
        canvas.width =this.width;
        canvas.height =this.height;

        let ctx = canvas.getContext('2d');
        ctx.drawImage(this, 0, 0);
        parent.headerImage = canvas.toDataURL('image/png');
      }
    })(this)
    imgAux.src = this.headerReport;
  },
  methods: {
    ...mapActions(['setVisibleExportPDFReportViewer','setLoadingMainApp','setMessageTextReportViewer','setMessageVisibleReportViewer','setDragModeReportViewer']),
    changeSelectionPageSize(value){
      this.selectionPageSize = value
    },
    closeAction(){
      this.setLoadingMainApp(false)
      this.setVisibleExportPDFReportViewer(false)
    },
    getFileName(){
      if(!RE_PDF_EXT.test(this.fileName)){
        return this.fileName +'.pdf'
      }
      return this.fileName
    },
    async exportSinglePagePDF(){
      this.setMessageTextReportViewer(exporting_Message)
      this.setMessageVisibleReportViewer(true)
      await this.$parent.$refs.reportBoardElem.setExportable()
      const editionModeBool=this.isEditModeReportViewer
      this.setDragModeReportViewer(false)
      try{
        this.$parent.isSignatureVisible = this.showSignatureValue
        const dataUrl = await domtoimage.toPng(this.$parent.$refs.exportableZone)
        this.$parent.$refs.reportBoardElem.resetExportable()
        const widthPX= this.$parent.$refs.exportableZone.scrollWidth;
        const heightPX = this.$parent.$refs.exportableZone.scrollHeight;
        const margin = 10
        const imgWidthMM = 210-(2*margin);
        let headerHeightMM = 25;
        if(this.headerImage===null){
          headerHeightMM = 0 //Set to zero if the header did not load properly. Weird cases.
        }
        const convertedHeightMM=heightPX*imgWidthMM/widthPX
        const doc = new jsPDF('p', 'mm',[210, convertedHeightMM+10+headerHeightMM]);
        if(this.headerImage!==null){
          doc.addImage(this.headerImage, 'PNG', margin, margin, imgWidthMM, headerHeightMM);
        }
        doc.addImage(dataUrl, 'JPEG', margin, margin+headerHeightMM, imgWidthMM, convertedHeightMM);
        doc.save(this.getFileName())
      } catch(e){
        const errText=`Error creating the A4 PDF. Message: ${e}`
        const errTitle='Error creating PDF'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,notifyZone)
      }finally{
        this.setDragModeReportViewer(editionModeBool)
        this.setMessageVisibleReportViewer(false)
        this.$parent.isSignatureVisible = false
      }
    },
    async exportA4PDF(){
      this.setMessageTextReportViewer(exporting_Message)
      this.setMessageVisibleReportViewer(true)
      await this.$parent.$refs.reportBoardElem.setExportable()
      const editionModeBool=this.isEditModeReportViewer
      this.setDragModeReportViewer(false)
      const pageHeight = 297
      const doc = new jsPDF('p', 'mm',[pageHeight, 210]);
      try{
        //Get the report info
        const margin = 10
        const imgWidthMM = 210-(2*margin);
        this.$parent.isSignatureVisible = this.showSignatureValue
        const reportInfoExport = await domtoimage.toPng(this.$parent.$refs.reportTextData)
        this.$parent.isSignatureVisible = false
        //Wait to hide the signature visibility
        await this.$nextTick()
        await this.$nextTick()
        const reportInfoHeight = this.getHeightMM(this.$parent.$refs.reportTextData, imgWidthMM)

        //Add the header to the PDF
        let headerHeightMM = 25;
        if(this.headerImage===null){
          headerHeightMM = 0 //Set to zero if the header did not load properly. Weird cases.
        }else{
          doc.addImage(this.headerImage, 'PNG', margin, margin, imgWidthMM, headerHeightMM);
        }

        //Add the report info to the PDF
        let positionY = margin+headerHeightMM
        this.addImageToDoc(doc, reportInfoExport, positionY, reportInfoHeight, imgWidthMM, pageHeight, margin)

        //Get the cards by separate
        const cardsDivsExport = await this.$parent.$refs.reportBoardElem.getExportableElements(imgWidthMM)
        this.$parent.$refs.reportBoardElem.resetExportable()

        //Add the cards independly on each page of the PDF
        if(cardsDivsExport.length > 0){
          let positionY = margin+headerHeightMM + reportInfoHeight+5
          this.addImageToDoc(doc, cardsDivsExport[0].element, positionY, cardsDivsExport[0].height, imgWidthMM, pageHeight, margin)
          for(let j=1;j<cardsDivsExport.length;j++){
            doc.addPage();
            let positionY = margin
            this.addImageToDoc(doc, cardsDivsExport[j].element, positionY, cardsDivsExport[j].height, imgWidthMM, pageHeight, margin)
          }
        }
        let fileName = this.fileName
        if(!fileName.endsWith('.pdf')){
          fileName += '.pdf'
        }
        doc.save(this.getFileName());

      } catch(e){
        const errText=`Error creating the Single Page PDF. Message: ${e}`
        const errTitle='Error creating PDF'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,notifyZone)

      }finally{
        this.setDragModeReportViewer(editionModeBool)
        this.setMessageVisibleReportViewer(false)
        this.$parent.isSignatureVisible = false
      }
    },
    fileNameValidation(fileName){
      if(fileName.length === 0){
        return false
      }
      if(fileName[0]==='.'){
        return false
      }
      //Add validation of the fileName
      return RE_VALID_FILENAME.test(fileName)
    },
    getHeightMM(div_element, imgWidthMM){
      const widthPX= div_element.clientWidth;
      const heightPX = div_element.clientHeight;
      const convertedHeightMM=heightPX*imgWidthMM/widthPX
      return convertedHeightMM
    },
    addImageToDoc(doc, elementAdd, positionY, elementHeightMM, elementWidthMM, pageHeight, margin){
      var heightLeft = elementHeightMM;
      const origPositionY = positionY
      doc.addImage(elementAdd, 'PNG', margin, positionY, elementWidthMM, elementHeightMM);
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        doc.addPage();
        positionY = origPositionY + heightLeft - elementHeightMM; // top padding for other pages
        doc.addImage(elementAdd, 'PNG', margin, positionY, elementWidthMM, elementHeightMM);
        heightLeft -= pageHeight;
      }
    },
    async exportPDF(){
      if(!this.fileNameValidation(this.fileName)){
        return
      }
      try{
        if(this.selectionPageSize === 'A4'){
          await this.exportA4PDF()
        }else{
          await this.exportSinglePagePDF()
        }
      }catch(e){
        const errText=`Error creating the PDF. Message: ${e}`
        const errTitle='Error creating PDF'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR,errTitle,errText,notifyZone)
      }finally{
        this.setVisibleExportPDFReportViewer(false)
        this.setLoadingMainApp(false)
      }

    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
#loading-animation{
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.buttons-page{
  position:absolute;
  bottom:0.5rem;
}
.btns-commands{
  right:0.5rem;
}
.main-container{
  height:80%;
}
::v-deep .titlebar{
  background: #343A40 !important;
  font-weight: bold;
  color:white;
}
.export-window{
  text-align: center;
}
</style>
